<template>
  <div class="layouts widget videoTour-widget" style="position: relative">
    <div class="accordion" role="tablist">
      <div
        class="widget-header mx-auto cursor-pointer rrr"
        v-show="isToolbarsCollapsed"
        @click.prevent="updateToolbarsStatus"
        @mouseover="increaseWidth"
        @mouseleave="resetWidth"
      >
        <img
          :src="require('@/assets/svg/layouts.svg')"
          alt="layouts"
          :style="{ width: hoverWidth, marginInline: 'auto' }"
          v-b-tooltip.hover.right.viewport="`Video Tour`"
        />
      </div>
      <div class="widget-header" v-show="!isToolbarsCollapsed">
        <div
          class="icon-title"
          v-if="!searchBarEnabled"
          v-b-toggle="collapsible ? `main-accordion-${id}` : ''"
        >
          <img
            :src="require('@/assets/svg/layouts.svg')"
            alt="layouts"
            :style="{ width: '16px', marginInline: '16px' }"
          />
          <p class="text-center">{{ title }}</p>
        </div>

        <div class="search-collapse" v-if="!searchBarEnabled && $can('create', 'VideoTour')">
          <i
            class="feather icon-plus-circle cursor-pointer fs-5"
            @click="openVideoTourModal(false)"
          ></i>
        </div>

        <div class="search-collapse" :class="[{ barEnable: searchBarEnabled }]">
          <img
            :src="require('@/assets/svg/search.svg')"
            alt="Search"
            :style="{ width: '18px', marginInline: '0.65rem' }"
            v-b-tooltip.hover.bottom.viewport="`${$t('search')}`"
            @click.stop="toggleSearchBar(true)"
            v-if="!searchBarEnabled"
          />
          <search-bar-widgets
            :search-bar-width="searchBarWidth"
            :sidebar-min-width-reached="sidebarMinWidthReached"
            @input="onSearchVideoTour"
            @toggle-search-bar="toggleSearchBar"
            @reset-search-bar="resetVideoTourSearchBar"
            v-if="searchBarEnabled"
            ref="videoTourSearchBar"
          />
        </div>
        <div>
          <template v-if="collapsible">
            <feather-icon
              v-if="!isConfigModeOn"
              :icon="isCollapseOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              size="24"
              v-b-toggle="collapsible ? `main-accordion-${id}` : ''"
            />
          </template>
          <span class="handle cursor-move" v-if="isConfigModeOn">
            <feather-icon icon="MenuIcon" size="18" />
          </span>
        </div>
      </div>
      <b-collapse
        :id="`main-accordion-${id}`"
        :accordion="`main-accordion-${id}`"
        role="tabpanel"
        v-model="isCollapseOpen"
        @input="onUpdateStatus"
        v-show="isCollapseOpen && !isToolbarsCollapsed"
      >
        <div
          v-if="loadingVideoTours"
          :class="[
            'layouts-container d-flex flex-wrap justify-content-between videoTourLoading',
            { 'flex-column': sidebarMinWidthReached },
          ]">
          <SkeletonLoading
            v-for="(load, index) in 4"
            :key="index+'skeleton'"
            class="videoTour-view-item"
            :width="210"
            :height="100"
          />
        </div>

        <div
          :class="[
            'layouts-container d-flex flex-wrap justify-content-between',
            { 'flex-column': sidebarMinWidthReached },
          ]"
          v-if="videoTours.length && !loadingVideoTours"
        >
          <div
            :class="[
              'videoTourItemConatiner',
              {
                'w-100': sidebarMinWidthReached,
                'w-50': !sidebarMinWidthReached,
              },
            ]"
            v-for="tour in videoTours"
            :key="tour.id"
          >
            <div class="videoTourItem cursor-pointer" @click.stop="setVideoTour(tour)">
              <feather-icon
                :id="`actions-theme-${tour.id}`"
                icon="MoreVerticalIcon"
                size="16"
                class="cursor-pointer tourActions"
                color="#3182ce"
                @click.stop
              />
              <b-popover
                :target="`actions-theme-${tour.id}`"
                triggers="focus"
                placement="bottom"
                custom-class="popover-p-0"
                variant="white"
              >
                <b-list-group class="m-0">
                  <b-list-group-item
                    class="border-0"
                    button
                    @click="openEditVideoTour(tour)"
                    v-if="$can('update', 'VideoTour')"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50 text-capitalize">
                      {{ $t("actions.edit") }}
                    </span>
                  </b-list-group-item>

                  <b-list-group-item
                    class="border-0"
                    button
                    @click="deleteVideoTour(tour)"
                    v-if="$can('delete', 'VideoTour')"
                  >
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50 text-capitalize">
                      {{ $t("actions.delete") }}
                    </span>
                  </b-list-group-item>
                </b-list-group>

                <b-list-group-item
                    class="border-0"
                    button
                    @click="openEditVideoTour(tour)"
                    v-if="tour.validations"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50 text-capitalize">
                      Ver historial
                    </span>
                  </b-list-group-item>
              </b-popover>
              <span class="h5">{{ tour.name }}</span>
              <div class="small">
                <span>{{ tour.tenant.name }}</span>
                -
                <span>{{ tour.config.length }} {{ $t("grid.widgets.views.title") }}</span>
              </div>
              <div class="tourPlayIcon">
                <svg
                  style="width: 30px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="1rem"
                  class="bi bi-play-circle-fill icon cursor-pointer"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"
                  />
                </svg>
                <!-- <feather-icon
                  :title="$t('detection_event.play')"
                  icon="PlayCircleIcon"
                  class="text-capitalize cursor-pointer"
                  v-b-tooltip.hover
                  size="25"
                /> -->
                <!-- <i class="feather icon-play-circle cursor-pointer" style="font-size: 30px;"></i> -->
              </div>
            </div>
          </div>
        </div>
        <div v-if="!videoTours.length && !loadingVideoTours">
          <p class="mb-0 py-1 lead text-center">{{ $t("no_record_found") }}</p>
        </div>
        <PaginationWidgets
          :sidebar-min-width-reached="sidebarMinWidthReached"
          :per-page.sync="videoTourPerPage"
          :current-page.sync="videoTourCurrentPage"
          :total-records="videoToursTotalRecords"
          @update:currentPage="updateVideoTourCurrentPage"
          @update:perPage="updateVideoTourPerPage"
        />
      </b-collapse>
    </div>
    <VideoTourModal
      :isEdit="isOpenEdit"
      :currentItemToEdit="currentItemToEdit"
      v-if="vidoTourModalIsOpen"
    />
  </div>
</template>

<script>
import { ref, watch, onMounted, computed, nextTick, onUnmounted } from "@vue/composition-api";
import { BCollapse, VBToggle } from "bootstrap-vue";
import store from "@/store";
import PaginationWidgets from "./components/PaginationWidgets.vue";
import SearchBarWidgets from "./components/SearchBarWidgets.vue";
import VideoTourModal from "@/views/components/GridView/widgets/VideoTourWidget/VideoTourModal.vue";
import { useVideoTour } from "@/composables/videoTour";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import { EventBus } from "@/libs/event-bus";

export default {
  components: {
    BCollapse,
  },
  components: {
    BCollapse,
    PaginationWidgets,
    SearchBarWidgets,
    VideoTourModal,
    SkeletonLoading
  },
  directives: {
    "b-toggle": VBToggle,
  },
  props: {
    id: {
      type: Number | String,
      default: 1,
    },
    location: {
      type: String,
      default: "sideBar",
    },
    title: {
      type: String | Number,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: String | Number,
      default: "sidebar",
    },
    selectedLayout: {
      type: String | Number,
      default: null,
    },
    ignoreCollapse: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isCollapseOpen = ref(false);
    const hoverWidth = ref("16px");
  const searchBarEnabled = ref(false);
  const searchBarWidth = ref(0);
  const videoTourSearchBar = ref(null);
    const {
      vidoTourModalIsOpen,
      videoTourPerPage,
      videoTourCurrentPage,
      videoTours,
      videoToursTotalRecords,
      isOpenEdit,
      currentItemToEdit,
      loadingVideoTours,
      openVideoTourModal,
      getVideoTours,
      updateVideoTourPerPage,
      updateVideoTourCurrentPage,
      onSearchVideoTour,
      resetVideoTourSearchBar,
      openEditVideoTour,
      deleteVideoTour,
      setVideoTour,
    } = useVideoTour();

    onMounted(() => {
      getVideoTours();
      isCollapseOpen.value = props.isOpen;
      searchBarWidth.value = (getElWidth() ?? 0) - 20;

      EventBus.on('video-tour-was-validated', async () => await getVideoTours());
    });

    onUnmounted(() => {
      EventBus.off('video-tour-was-validated', async () => await getVideoTours());
    });

    function getElWidth() {
      return document.querySelector(".videoTour-widget")?.offsetWidth;
    }
    const sidebarWidth = computed(() => store.state.grid.sidebarWidth);
    const isConfigModeOn = computed(() => store.state.psimConfig.configModeStatus);
    const sidebarMinWidthReached = computed(
      () => store.getters["grid/sidebarMinWidthReached"]
    );
    const isToolbarsCollapsed = computed(() => {
      if (props.ignoreCollapse) return false;
      return store.state.psimConfig.isToolbarsCollapsed;
    });
    const isReloadingWidget = computed(() => store.getters["grid/isReloadingWidget"]);

    watch(
      sidebarWidth,
      () => {
        searchBarWidth.value = (getElWidth() ?? 0) - 20;
      }
    );

    watch(
      () => isReloadingWidget.value,
      (newValue) => {
        getVideoTours();
      }
    );

    function toggleSearchBar(forceValue) {
      if (forceValue === true) {
        openSearchBar();
        return;
      }
      if (forceValue === false) {
        closeSearchBar();
        return;
      }

      if (searchBarEnabled.value) {
        closeSearchBar();
      } else {
        openSearchBar();
      }
    }

    function openSearchBar() {
      if (searchBarEnabled.value) return;
      searchBarEnabled.value = true;
      isCollapseOpen.value = true;
      nextTick(() => {
        if (videoTourSearchBar.value?.focusInput) {
          videoTourSearchBar.value.focusInput();
        }
      });
    }

    function closeSearchBar() {
      if (!searchBarEnabled.value) return;
      searchBarEnabled.value = false;
      resetVideoTourSearchBar();
    }

    function onUpdateStatus(value) {
      emit("widget-collapsed", {
        id: props.id,
        property: "isOpen",
        location: props.location,
        value,
      });
    }

    function updateToolbarsStatus() {
      store.commit(
        "psimConfig/UPDATE_TOOLBARS_COLLAPSED",
        !store.state.psimConfig.isToolbarsCollapsed
      );
      isCollapseOpen.value = true;
    }

    function increaseWidth() {
      hoverWidth.value = "22px";
    }

    function resetWidth() {
      hoverWidth.value = "16px";
    }

    return {
      isCollapseOpen,
      hoverWidth,
      videoTourPerPage,
      videoTourCurrentPage,
      searchBarEnabled,
      searchBarWidth,
      videoTourSearchBar,
      isConfigModeOn,
      sidebarMinWidthReached,
      isToolbarsCollapsed,
      vidoTourModalIsOpen,
      videoTours,
      videoToursTotalRecords,
      isOpenEdit,
      currentItemToEdit,
      loadingVideoTours,
      onSearchVideoTour,
      resetVideoTourSearchBar,
      toggleSearchBar,
      openSearchBar,
      closeSearchBar,
      updateVideoTourCurrentPage,
      updateVideoTourPerPage,
      onUpdateStatus,
      updateToolbarsStatus,
      increaseWidth,
      resetWidth,
      openVideoTourModal,
      openEditVideoTour,
      deleteVideoTour,
      setVideoTour,
    };
  },
};
</script>
